import * as React from "react";
import { cn } from "@/lib/utils";
import { getProviderDisplayPhoto, avatarOnError, type ProviderAvatarFields } from "@/lib/provider-avatar";

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
 provider: ProviderAvatarFields;
};

/**
 * Renders a provider's photo with automatic default-silhouette fallback.
 * Never shows a broken image, onError swaps to the matching silhouette.
 */
export function ProviderPhoto({ provider, className, alt, ...rest }: Props) {
 const src = getProviderDisplayPhoto(provider);
 return (
 <img
 src={src}
 alt={alt || provider.name || "Provider"}
 onError={avatarOnError(provider)}
 loading="lazy"
 decoding="async"
 className={cn("object-cover bg-muted", className)}
 {...rest}
 />
 );
}
